import { Loader, LogOut, RotateCw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Spacing from "../Spacing";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { useEffect, useState } from "react";
import { useLogout } from "../../hooks/useLogout";

const NoPracticesFoundPage = () => {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(true);
  const portalLogout = useLogout();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowContent(false);
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  // TODO: chec refresh logic is correct or not later
  const handleRefresh = () => {
    console.log("Refresh page");
    navigate("/");
  };

  // useEffect(() => {
  //   const detectUser = async () => {
  //     const accountNames = await getSecureData("account_names");
  //     if(accountNames) {
  //       handleRefresh();
  //     }
  //   };

  //   detectUser();
  // }, []);

  useDocumentTitle("Practice Not Found");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      {showContent ? 
        <>
          <div className="flex items-center loading" style={{ width: '100%', height: '100vh', justifyContent: 'center' }}>
            <span className="docpro_loading" style={{ position: 'inherit' }}>
              <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
            </span>
          </div>
        </>
      :
        <>
          <h1 style={{ fontSize: "3rem", color: "#333" }}>No Practices Found</h1>
          <p style={{ fontSize: "1.5rem", color: "#666" }}> You don't have any practices assigned to you. Kindly contact to your system administrator </p>

          <Spacing lg="20" sm="20" />
          <div className="flex items-center docpro_grid_gap_10">
            <button
              onClick={handleRefresh}
              className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
            >
              <RotateCw width={15} height={15} />
              <span>Refresh</span>
            </button>
            <button
              type="button"
              onClick={portalLogout}
              className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
              style={{ backgroundColor: '#e0483d', borderColor: '#c33f35' }}
            >
              <LogOut width={15} height={15} />
              <span>Log Out</span>
            </button>
          </div>
        </>
      }
    </div>
  );
};

export default NoPracticesFoundPage;
